export default __webpack_public_path__ + "static/media/machinery.9fe03220.jpg";